import { VehicleModel }                  from '../../app-lite/vehicles/models/vehicle';
import { VehicleRegistrationServiceAjs } from './vehicle-registration.service.ajs';

interface VehicleRegistrationStatusScope extends ng.IScope {
  getClasses      : () => Array<string>;
  getStatusMessage: () => string;
  vehicle         : VehicleModel;
}

export function VehicleRegistrationStatusCtrl (
  $scope                : VehicleRegistrationStatusScope,
  $translate            : ng.translate.ITranslateService,
  vehicleRegistrationApi: VehicleRegistrationServiceAjs
) {
  $scope.getClasses = function () : Array<string> {
    const classes = [];

    if (vehicleRegistrationApi.hasRegistrationId($scope.vehicle)) {
      classes.push('bg-success');
    }
    else {
      classes.push('bg-danger');
    }

    return classes;
  };

  $scope.getStatusMessage = function () : string {
    return vehicleRegistrationApi.hasRegistrationId($scope.vehicle)
    ? $translate.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.VERIFIED')
    : $translate.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.NOT_VERIFIED');
  };
}
